export default __webpack_public_path__ + "static/media/mobileApp.10475ff6.png";